import type React from 'react';

import { SearchIcon } from '@vlabs/icons';
import type { InputProps } from '@vlabs/uikit/components/controls/input/Input';
import { Input } from '@vlabs/uikit/components/controls/input/Input';

import { useSearchUsersByTranslation } from './i18n';
import { useSearchUsersBy } from './model/SearchUsersByContext';
import { buildTestid } from '../../../shared/lib/utils';

const displayName = 'SearchUsersBy';
const testid = buildTestid(displayName);

type SearchUsersByProps = Omit<InputProps, 'isClearable' | 'onChangeValue' | 'onClear' | 'value'>;

function SearchUsersBy({
  'data-testid': dataTestId = undefined,
  ...props
}: SearchUsersByProps): React.JSX.Element | null {
  const { t } = useSearchUsersByTranslation();
  const searchUsersBy = useSearchUsersBy();

  if (!searchUsersBy) {
    return null;
  }

  return (
    <Input
      {...props}
      icon={<SearchIcon />}
      isClearable
      onChangeValue={searchUsersBy.setValue}
      onClear={() => searchUsersBy.setValue('')}
      placeholder={t('input.placeholder')}
      value={searchUsersBy.value}
      {...testid(dataTestId)}
    />
  );
}

SearchUsersBy.displayName = displayName;

export { SearchUsersBy };
